import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from "./Tooltip";
import Localizer from '../helpers/Localizer';

const Wrapper = styled.div` 

        position:absolute;
        top: -21px;
        transform: translate(-50%, -50%); 
        height: 30px;
        border: 1px solid #d01f49;
        color: #000; 
        background: #ffffff;
        padding: 5px 15px 5px 0;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-family: "Montserrat", sans-serif;
        font-weight: 200;
        margin-bottom: 0;
        font-size: 14px;
        cursor: pointer;
     
    &:hover { 
        z-index: 1;  
    }
    &::before {  
        content: "${props => (props.item.base_guests)}p";
    background-color: #d01f49;
    color: #fff; 
    width: 100%;
    height: 100%;
    margin: 0;
    border-radius: 5px 0 0 5px;
    PADDING: 5px;
    margin-left: -1px;
    margin-right: 10px;
    }
    
    &:after {
        content:'';
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-top: solid 7px #d01f49; 
        border-left: solid 7px transparent;
        border-right: solid 7px transparent; 
    }
`;

class PricedMarker extends Component {

    static propTypes = {
        item: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        price: PropTypes.object.isRequired,
        showTooltip: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        onTooltipClose: PropTypes.func.isRequired
    };

    render() {

        const locale = document.getElementsByTagName('html')[0].getAttribute('lang');

        return (
            <div>
                <Tooltip visible={this.props.showTooltip}
                         item={this.props.item}
                         price={this.props.price}
                         type={this.props.type}
                         onClose={this.props.onTooltipClose}
                />
                <Wrapper
                    onClick={() => {
                        this.props.onClick();
                    }}
                    {...this.props.type ? {type: this.props.type} : {}}
                    {...this.props.item ? {item: this.props.item} : {}}
                >{Localizer.roundEuro(this.props.price.total_price, locale)}</Wrapper>
            </div>
        );
    };
}

export default PricedMarker;